import Axios from "axios";
import { allStates } from '../enums/state';

const urls = {
    controller: {
        locations: '/api/locations',
        states: '/api/player/states',
        companySettings: '/api/company-settings',
    },
    designer: {
        locations: '/api/locations',
        states: '/api/states',
        companySettings: '/api/company-settings',
    }
}

const dataLoadMiddleware = async (store, to, from, next, types, appType) => {
    if (store.state.user) {
        const requestConfig = store.state.token ? {
            headers: {
                Authorization: `Bearer ${store.state.token}`
            }
        } : {};

        if (types.indexOf('locations') !== -1 && store.state.locations === null) {
            const response = await Axios.get(urls[appType].locations, requestConfig);

            store.dispatch('setLocations', response.data);
        }

        if (types.indexOf('companySettings') !== -1 && store.state.companySettings === null && to.name !== 'blocks') {
            const response = await Axios.get(urls[appType].companySettings, requestConfig);

            store.dispatch('setCompanySettings', response.data);
        }

        if (types.indexOf('states') !== -1 && store.state.states === null) {
            // No need to load this from the backend since it will probably never change
            store.dispatch('setStates', allStates);
        }
    }

    return next();
}

export default dataLoadMiddleware;
